// =============================
// Config
// =============================
// Locales that exist for Admin-v2 & Meta Ingestion

export const languagesNames = {
  en: {
    name: 'English',
    nativeName: 'English',
  },
  fr: {
    name: 'French',
    nativeName: 'Français',
  },
  de: {
    name: 'German',
    nativeName: 'Deutsch',
  },
  es: {
    name: 'Spanish',
    nativeName: 'Español',
  },
  ja: {
    name: 'Japanese',
    nativeName: '日本語',
  },
};

export const languagesList = ['en', 'fr', 'de', 'es', 'ja'];

export const defaultLanguage = 'en';

const locales = {
  languagesNames,
  languagesList,
  defaultLanguage,
};

export default locales;
